import React, { useState, useEffect } from "react";
import "./style.css";
import LogoEE from "../../image/Cargador Frontal Komatsu WA320-6.jpeg";
import SY956H from "../../image/SY956H.jpg";

import { Row, Col } from "antd";
import NavbarComponent from "../NavbarComponent";
import Footer from "../FooterComponent";
import { useDispatch } from "react-redux";
import { updateProductsState } from "../../store/profile";
import { useSelector } from "react-redux";

import { checkCartIfExist } from "../../helper";
import { LoadingOutlined } from "@ant-design/icons";
function TwentySection() {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.profile);

  const [loading, setloading] = useState(false);
  const [hitUseEffect, sethitUseEffect] = useState(false);

  const handleLoading = () => {
    setloading(false);
  };

  useEffect(() => {
    setloading(true);

    setTimeout(handleLoading, 1000);
  }, [hitUseEffect, products]);
  return (
    <>
      <NavbarComponent />
      <div>
        <div className="border">
          <Row className="rowo" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={LogoEE} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">KOMATSU WA320-6</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Motor</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">171 HP</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad cucharón</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">2.6 m3</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Peso operativo</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">14,330 Kg</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("KOMATSU WA320-6") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "CARGADOR FRONTAL",
                                  name: "KOMATSU WA320-6",
                                  motor: "171 HP",
                                  capacidad_cucharón: "2.6 m3",
                                  peso_operativo: "14,330 Kg",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={SY956H} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">SANY SY956H</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Motor</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">223 HP</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad cucharón</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">3 m3</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Peso operativo</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">17.1 TON</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("SANY SY956H") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "CARGADOR FRONTAL",
                                  name: "SANY SY956H",
                                  motor: "223 HP",
                                  capacidad_cucharón: "3 m3",
                                  peso_operativo: "17.1 TON",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TwentySection;
